export const addRecentlyViewedProduct = (product: any) => {
  if (!product.tags.find((tag: String) => tag === 'search:hidden')) {
    product = normalizeProductForStorage(product)
    const storage = window.localStorage
    const productsString = storage.getItem('AddonProducts')
    let products: any[] = []
    if (productsString) {
      products = JSON.parse(productsString)

      // check if product is already in the recently viewed list. If yes, remove it from its index
      const existingIndex = products.findIndex((p) => p.id === product.id)
      if (existingIndex > -1) {
        products.splice(existingIndex, 1)
      }
      // remove last element if there are already 10 recently viewed products
      if (products.length > 9) {
        products.pop()
      }
      products.unshift(product)
    } else {
      products.push(product)
    }
    storage.setItem('AddonProducts', JSON.stringify(products))
  }
}

export const getRecentlyViewedProducts = (): any[] => {
  const storage = window.localStorage
  let products: any[] = []
  const productsString = storage.getItem('AddonProducts')
  if (productsString) {
    products = JSON.parse(productsString)
  }
  return products
}

const normalizeProductForStorage = (
  product: any
): {
  id: string
  description?: string
  name?: string
  price?: {
    value: number
    listPrice: number
    minVariantPrice?: number
    maxVariantPrice?: number
  }
  slug?: string
  images?: any[]
  path?: string
  vendor?: string
  metafields?: any[]
  tags?: string[]
} => {
  const availableVariants =
    product.variants?.filter((v: any) => v.availableForSale) ?? []
  const inStockPrices = availableVariants.map((v: any) => v.price)
  const minVariantPrice =
    inStockPrices.length > 0
      ? Math.min(...inStockPrices)
      : product.variants?.[0]?.price
  const maxVariantPrice =
    inStockPrices.length > 0
      ? Math.max(...inStockPrices)
      : product.variants?.[0]?.price
  return {
    id: product.id,
    description: product.description,
    name: product.name,
    price: {
      value: minVariantPrice ?? product.variants?.[0]?.price,
      listPrice: product.variants?.[0]?.listPrice,
      minVariantPrice,
      maxVariantPrice,
    },
    slug: product.slug,
    images: product.images,
    path: product.path,
    metafields: product.metafields,
    vendor: product.vendor,
    tags: product.tags,
  }
}
